import { apiFetch } from "@/lib/api";

export type LegacyClient = {
  id: number;
  first_name: string;
  last_name: string;
  name?: string | null;
  company?: string | null;
  group_name?: string | null;
  email?: string | null;
  mobile?: string | null;
  alternate_phone?: string | null;
  referred_from?: string | null;
  language?: string | null;
  currency?: string | null;
  created_at?: string;
  updated_at?: string;
};

export type LegacyClientListItem = {
  id: number;
  first_name: string;
  last_name: string;
  company?: string | null;
  email?: string | null;
  mobile?: string | null;
  language?: string | null;
  currency?: string | null;
};

export type LegacyClientListResponse = {
  items: LegacyClientListItem[];
  total: number;
};

export const fetchLegacyClients = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<LegacyClientListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  const payload = await apiFetch<LegacyClientListResponse | null>(`/legacy-clients?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getLegacyClient = async (id: number): Promise<LegacyClient> => {
  return apiFetch<LegacyClient>(`/legacy-clients/${id}`);
};

export const createLegacyClient = async (data: Partial<LegacyClient>): Promise<LegacyClient> => {
  return apiFetch<LegacyClient>("/legacy-clients", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const createLegacyClientImport = async (data: Partial<LegacyClient>): Promise<LegacyClient> => {
  return apiFetch<LegacyClient>("/legacy-clients/import", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateLegacyClient = async (id: number, data: Partial<LegacyClient>): Promise<LegacyClient> => {
  return apiFetch<LegacyClient>(`/legacy-clients/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteLegacyClient = async (id: number): Promise<void> => {
  await apiFetch<void>(`/legacy-clients/${id}`, { method: "DELETE" });
};

export const deleteAllLegacyClients = async (): Promise<void> => {
  await apiFetch<void>("/legacy-clients", { method: "DELETE" });
};
